import React from 'react';
import { TownStateProvider, useTownState } from './context/TownStateContext';
import Town from './components/Town';
import CharacterInfoPanel from './components/CharacterInfoPanel';
import { SimulationControls } from './components/SimulationControls';
import ConversationLog from './components/ConversationLog';
import KanbanBoard from './components/KanbanBoard';
import './App.css';

const App: React.FC = () => {
  const { selectedCharacter } = useTownState();

  return (
    <div className="App">
      <header className="header">
        <h1>🏢 The Virtual Software House</h1>
      </header>
      <div className="main-container">
        <div className="left-panel">
          <SimulationControls />
          <Town />
          <KanbanBoard />
        </div>
        <div className="right-panel">
          <div className="character-info">
            <CharacterInfoPanel />
          </div>
          <div className="conversation-log-wrapper">
            <ConversationLog />
          </div>
        </div>
      </div>
    </div>
  );
};

const RootApp: React.FC = () => (
  <TownStateProvider>
    <App />
  </TownStateProvider>
);

export default RootApp;